class CartRemoveButton extends HTMLElement {
  constructor() {
    super(),
      this.addEventListener("click", (t) => {
        t.preventDefault();
        let e = this.closest("cart-items") || this.closest("cart-drawer-items");
        //e.updateQuantity(this.dataset.index, 0),
          setTimeout(function () {
            //$(".upsell_responsive .collection_upsell_list").slick();
          }, 1e3);
        let r = this.closest("tr");
        if ("true" === r.getAttribute("having-id")) {
          var a,
            i = $(this).parents(".cart-item").attr("matchid"),
            i1 = $(this).parents(".cart-item").data("id-product"),
            n = $(".cart-item[varid='" + i + "']").attr("varid"),
            s =
              document.querySelector("cart-notification") ||
              document.querySelector("cart-drawer");
          [
            { id: i1, quantity: 0 },
            { id: n, quantity: 0 },
          ].forEach(function (t) {

            $.ajax({
              type: "GET",
              url: "/cart/change.js",
              data: {
                id: t.id,
                quantity: t.quantity,
                sections: s.getSectionsToRender().map((t) => t.id),
                sections_url: window.location.pathname,
              },
              dataType: "json",
              async:false,
              success: function (t) {
                s.renderContents(t),
                  0 == t.item_count && $(".drawer").addClass("is-empty");
                  
              },
              error: function () {
                console.log("error");
              },
            });
          });
        }
        
        if ("false" === r.getAttribute("having-id")) {
       
if($(this).attr("itemtag") == "free-product"){
         let r = $(this).parents("tr");
        if ("false" === r.attr("having-id")) {
          var a;
          var i = $(this).parents(".cart-item").attr("varid");
            var i2=  $('.cart-item[having-id="true"][matchid="'+i+'"]').data("id-product");
            //n = $(".cart-item[varid='" + i + "']").attr("varid"),
            var s =
              document.querySelector("cart-notification") ||
              document.querySelector("cart-drawer");
          [
            { id: i2, quantity: 0 },
            { id: i, quantity: 0 },
          ].forEach(function (t) {
console.log(t);
            $.ajax({
              type: "GET",
              url: "/cart/change.js",
              data: {
                id: t.id,
                quantity: t.quantity,
                sections: s.getSectionsToRender().map((t) => t.id),
                sections_url: window.location.pathname,
              },
              dataType: "json",
              async:false,
              success: function (t) {
                s.renderContents(t),
                  0 == t.item_count && $(".drawer").addClass("is-empty");
                  
              },
              error: function () {
                console.log("error");
              },
            });
          });
        }

}else{
          e.updateQuantity(this.dataset.index, 0)
}

       } 
      });
  }
}
customElements.define("cart-remove-button", CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super(),
      (this.lineItemStatusElement =
        document.getElementById("shopping-cart-line-item-status") ||
        document.getElementById("CartDrawer-LineItemStatus"));
    let t = debounce((t) => {
      this.onChange(t);
    }, ON_CHANGE_DEBOUNCE_TIMER);
    this.addEventListener("change", t.bind(this));
  }
  cartUpdateUnsubscriber = void 0;
  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (t) => {
      "cart-items" !== t.source && this.onCartUpdate();
    });
  }
  disconnectedCallback() {
    this.cartUpdateUnsubscriber && this.cartUpdateUnsubscriber();
  }
  onChange(t) {
    this.updateQuantity(
      t.target.dataset.index,
      t.target.value,
      document.activeElement.getAttribute("name"),
      t.target.dataset.quantityVariantId
    );
  }
  onCartUpdate() {
    "CART-DRAWER-ITEMS" === this.tagName
      ? fetch(`${routes.cart_url}?section_id=cart-drawer`)
          .then((t) => t.text())
          .then((t) => {
            let e = new DOMParser().parseFromString(t, "text/html");
            for (let r of ["cart-drawer-items", ".cart-drawer__footer"]) {
              let a = document.querySelector(r),
                i = e.querySelector(r);
              a && i && a.replaceWith(i);
            }
          })
          .catch((t) => {
            console.error(t);
          })
      : fetch(`${routes.cart_url}?section_id=main-cart-items`)
          .then((t) => t.text())
          .then((t) => {
            let e = new DOMParser().parseFromString(t, "text/html"),
              r = e.querySelector("cart-items");
            this.innerHTML = r.innerHTML;
          })
          .catch((t) => {
            console.error(t);
          });

  }
  getSectionsToRender() {
    return [
      {
        id: "main-cart-items",
        section: document.getElementById("main-cart-items").dataset.id,
        selector: ".js-contents",
      },
      {
        id: "cart-icon-bubble",
        section: "cart-icon-bubble",
        selector: ".shopify-section",
      },
      {
        id: "cart-live-region-text",
        section: "cart-live-region-text",
        selector: ".shopify-section",
      },
      {
        id: "main-cart-footer",
        section: document.getElementById("main-cart-footer").dataset.id,
        selector: ".js-contents",
      },
    ];
  }
  updateQuantity(t, e, r, a) {
    this.enableLoading(t);
    let i = JSON.stringify({
      line: t,
      quantity: e,
      sections: this.getSectionsToRender().map((t) => t.section),
      sections_url: window.location.pathname,
    });
    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), body: i })
      .then((t) => t.text())
      .then((e) => {
        let i = JSON.parse(e),
          n =
            document.getElementById(`Quantity-${t}`) ||
            document.getElementById(`Drawer-quantity-${t}`),
          s = document.querySelectorAll(".cart-item");
        if (i.errors) {
          (n.value = n.getAttribute("value")),
            this.updateLiveRegions(t, i.errors);
          return;
        }
        this.classList.toggle("is-empty", 0 === i.item_count);
        let c = document.querySelector("cart-drawer"),
          o = document.getElementById("main-cart-footer");
        o && o.classList.toggle("is-empty", 0 === i.item_count),
          c && c.classList.toggle("is-empty", 0 === i.item_count),
          this.getSectionsToRender().forEach((t) => {
            let e =
              document.getElementById(t.id).querySelector(t.selector) ||
              document.getElementById(t.id);
            e.innerHTML = this.getSectionInnerHTML(
              i.sections[t.section],
              t.selector
            );
          });
        let l = i.items[t - 1] ? i.items[t - 1].quantity : void 0,
          d = "";
        s.length === i.items.length &&
          l !== parseInt(n.value) &&
          (d =
            void 0 === l
              ? window.cartStrings.error
              : window.cartStrings.quantityError.replace("[quantity]", l)),
          this.updateLiveRegions(t, d);
        let m =
          document.getElementById(`CartItem-${t}`) ||
          document.getElementById(`CartDrawer-Item-${t}`);
        m && m.querySelector(`[name="${r}"]`)
          ? c
            ? trapFocus(c, m.querySelector(`[name="${r}"]`))
            : m.querySelector(`[name="${r}"]`).focus()
          : 0 === i.item_count && c
          ? trapFocus(
              c.querySelector(".drawer__inner-empty"),
              c.querySelector("a")
            )
          : document.querySelector(".cart-item") &&
            c &&
            trapFocus(c, document.querySelector(".cart-item__name")),
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: "cart-items",
            cartData: i,
            variantId: a,
          });
      })
      .catch(() => {
        this.querySelectorAll(".loading-overlay").forEach((t) =>
          t.classList.add("hidden")
        );
        let t =
          document.getElementById("cart-errors") ||
          document.getElementById("CartDrawer-CartErrors");
        t.textContent = window.cartStrings.error;
      })
      .finally(() => {
        this.disableLoading(t);
      });

   
  }
  updateLiveRegions(t, e) {
    let r =
      document.getElementById(`Line-item-error-${t}`) ||
      document.getElementById(`CartDrawer-LineItemError-${t}`);
    r && (r.querySelector(".cart-item__error-text").innerHTML = e),
      this.lineItemStatusElement.setAttribute("aria-hidden", !0);
    let a =
      document.getElementById("cart-live-region-text") ||
      document.getElementById("CartDrawer-LiveRegionText");
    a.setAttribute("aria-hidden", !1),
      setTimeout(() => {
        a.setAttribute("aria-hidden", !0);
      }, 1e3);
  }
  getSectionInnerHTML(t, e) {
    return new DOMParser().parseFromString(t, "text/html").querySelector(e)
      .innerHTML;
  }
  enableLoading(t) {
    let e =
      document.getElementById("main-cart-items") ||
      document.getElementById("CartDrawer-CartItems");
    e.classList.add("cart__items--disabled");
    let r = this.querySelectorAll(`#CartItem-${t} .loading-overlay`),
      a = this.querySelectorAll(`#CartDrawer-Item-${t} .loading-overlay`);
    [...r, ...a].forEach((t) => t.classList.remove("hidden")),
      document.activeElement.blur(),
      this.lineItemStatusElement.setAttribute("aria-hidden", !1);
  }
  disableLoading(t) {
    let e =
      document.getElementById("main-cart-items") ||
      document.getElementById("CartDrawer-CartItems");
    e.classList.remove("cart__items--disabled");
    let r = this.querySelectorAll(`#CartItem-${t} .loading-overlay`),
      a = this.querySelectorAll(`#CartDrawer-Item-${t} .loading-overlay`);
    r.forEach((t) => t.classList.add("hidden")),
      a.forEach((t) => t.classList.add("hidden"));
  }
}
customElements.define("cart-items", CartItems),
  customElements.get("cart-note") ||
    customElements.define(
      "cart-note",
      class t extends HTMLElement {
        constructor() {
          super(),
            this.addEventListener(
              "change",
              debounce((t) => {
                let e = JSON.stringify({ note: t.target.value });
                fetch(`${routes.cart_update_url}`, {
                  ...fetchConfig(),
                  body: e,
                });
              }, ON_CHANGE_DEBOUNCE_TIMER)
            );
        }
      }
    );
